import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata';
import OurApproach from './components/ourApproach';
import OurServices from './components/ourServices';
import PcgDirectory from './components/pcgDirectory';
import TestimonialSection from './components/testimonialSection';
import ThoughtLeaders from './components/thoughtLeaders';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/pcg-hero.webp';
import highResMobileImage from './components/heroSection/images/pcg-hero-mobile.webp';
// dislaimer footnotes
import {
  HighestFinancialStrengthRatings,
  RankingNmInvestmentsServices,
} from '../../utils/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();
  const youtubeVideoId = 'E77uv-lXV0Y';

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      useReCaptcha={false}
      disableDisclaimerTopBorder
      disclaimerFootnotes={[
        <>
          {RankingNmInvestmentsServices(1)}
        </>,
        <>
          <sup>2</sup>&nbsp;By the Northwestern Mutual Wealth Management Company and Northwestern Mutual Investment Services as of December 31, 2023.
        </>,
        <>
          {HighestFinancialStrengthRatings(3)}
        </>,
      ]}
      customDisclaimers={[
        <>
          Northwestern Mutual Private Client Group is a select group of Northwestern Mutual advisors and representatives. Northwestern Mutual Private Client Group is not a registered investment adviser, broker&#45;dealer, insurance agency, federal savings bank or other legal entity.
        </>,
      ]}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Investments',
          linkUrl: '/investments/',
          linkAriaLabel: 'Northwestern Mutual Investments',
        },
        {
          pageName: 'Private Wealth Management',
          linkUrl: '/private-wealth-management/',
          linkAriaLabel: 'Northwestern Mutual Private Wealth Management',
        },
      ]}>
      <Head>
        {/* prefetch expensive images and videos */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
        <link rel='preload' href={`https://www.youtube.com/embed/${youtubeVideoId}`} as='document' />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection videoId={youtubeVideoId}/>

      <OurServices />

      <TestimonialSection />

      <OurApproach />

      <PcgDirectory config={config} />

      <CredentialCalloutGrouping />

      <ThoughtLeaders />

      <ContentHub
        sectionId='content-hub'
        backgroundVariant='lightB'
        headingText='Related private wealth management articles'
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
        branding='pcg'
      />

    </Page>
  );
};
